<template>
  <v-card class="user-profile-card pa-4">
    <h3 class="mb-3">Change Password</h3>
    <v-alert :type="alertType">{{alertMessage}}</v-alert>
    <v-form dense v-model="isValid" class="ma-3">
      <v-text-field
        outlined
        required
        label="Current Password"
        type="password"
        v-model="currentPassword"
        :rules="[(v) => !!v || 'Current password is required']"
      ></v-text-field>
      <v-text-field
        outlined
        required
        label="Create New Password"
        type="password"
        v-model="newPassword"
        :rules="passwordRules"
      ></v-text-field>
      <PasswordRules :password="newPassword" />
      <v-text-field
        outlined
        required
        label="Confirm New Password"
        type="password"
        v-model="newPasswordConfirm"
        :rules="[
          (v) => !!v || 'Confirm password is required',
          (v) => v === newPassword || 'Passwords do not match'
        ]"
      ></v-text-field>
      <v-row>
        <v-spacer />
        <v-btn
          class="white--text"
          large
          v-on:click="changePassword"
          :dark="isValid"
          :disabled="!isValid"
          color="primary"
          >Submit</v-btn
        >
      </v-row>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import PasswordRules from '@/components/common/PasswordRules.vue';

import passwordValidators from '@/helpers/validate-password';

import { UserInfo } from "@/types/User";
import personService from "@/services/portal/personService";

export default Vue.extend({
  name: "ChangePassword",
  components: { PasswordRules },
  data: function () {
    return {
      isValid: false,
      alertType: "info",
      alertMessage:
        "To change your password, enter your current password and your new password below.",
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      passwordRules: passwordValidators,
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    changePassword() {
      personService
        .changePassword(
          this.currentPassword,
          this.newPassword
        )
        .then((res) => {
          if (res.success) {
            this.alertType = "success";
            this.alertMessage = "Password updated successfully!";
          } else if (res.errorMessage) {
            this.alertType = "error";
            this.alertMessage = res.errorMessage;
          } else {
            this.alertType = "error";
            this.alertMessage = "Something unexpectedly went wrong.";
          }
        });
    },
  },
});
</script>
